/**
 * @file Purchased custom print configuration notice.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import pluralize from 'pluralize';
import classNames from 'classnames';

import { getPurchasedCustomPrintName } from '../../../util/custom-prints';
import ArrowRight from '../../icons/ArrowRight';
import CustomPrintIcon from './CustomPrintIcon';

const propTypes = {
  purchasedCustomPrints: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string,
    }).isRequired,
  ).isRequired,
  album: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  className: PropTypes.string,
};

const PurchasedCustomPrintConfigNotice = ({
  purchasedCustomPrints,
  album,
  className,
}) => {
  const [purchasedCustomPrint] = purchasedCustomPrints;
  const name = getPurchasedCustomPrintName(purchasedCustomPrint);
  const amount = purchasedCustomPrints.length;
  const classes = classNames({
    'custom-print-config-notice': true,
    [className]: !!className,
  });

  return (
    <Link
      to={`/purchase/album/${album.id}/custom-prints/${purchasedCustomPrint.id}`}
      className={classes}
    >
      <div className="custom-print-config-notice-icon">
        <CustomPrintIcon backgroundColor="#7ace20" color="#fff" />
      </div>

      <div className="custom-print-config-notice-text">
        <p className="m-0">
          Looks like you have {amount}{' '}
          <strong>{pluralize(name, amount)}</strong>!
          <span className="text-xs d-block">
            Press here to customize {amount > 1 ? 'them' : 'it'}!
          </span>
        </p>

        <ArrowRight color="#7ace20" size="48" />
      </div>
    </Link>
  );
};

PurchasedCustomPrintConfigNotice.propTypes = propTypes;

export default PurchasedCustomPrintConfigNotice;
